import {
  setMessageVisibility,
  getCheckoutCoownersData,
  getQuotation,
  getIsOperatorFromSelector,
} from 'app/services/businessFunctionHelpers';
import { MessagesEnum, FormsEnum } from 'app/shared/enums';
import { checkIsDataObfuscated } from 'app/services/businessFunctions/helpers/checkIsDataObfuscated';
import { handleObfuscatedFieldConsentReset } from 'app/services/businessFunctions/helpers/handleObfuscatedFieldConsentReset';

const obfuscation = {
  showCoownersName2ObfuscatedMessage(initialRun?: boolean) {
    const { nameCheckoutForm } = getCheckoutCoownersData()[2];
    const quotation = getQuotation();
    const isOperator = getIsOperatorFromSelector();
    handleObfuscatedFieldConsentReset({
      value: nameCheckoutForm || '',
      initialRun,
      messageKey: MessagesEnum.Coowners2NameObfuscated,
      formName: FormsEnum.CheckoutForm,
      quotation,
      isOperator,
      resetTarget: {
        type: 'person',
        trackedPerson: 'coowner2',
        field: 'name',
      },
    });
  },
  showCoowners2LastNameObfuscatedMessage(initialRun?: boolean) {
    const { lastNameCheckoutForm } = getCheckoutCoownersData()[2];
    const quotation = getQuotation();
    const isOperator = getIsOperatorFromSelector();
    handleObfuscatedFieldConsentReset({
      value: lastNameCheckoutForm || '',
      initialRun,
      messageKey: MessagesEnum.Coowners2LastNameObfuscated,
      formName: FormsEnum.CheckoutForm,
      quotation,
      isOperator,
      resetTarget: {
        type: 'person',
        trackedPerson: 'coowner2',
        field: 'lastName',
      },
    });
  },
  showCoowners2PeselObfuscatedMessage(initialRun?: boolean) {
    const { peselCheckoutForm } = getCheckoutCoownersData()[2];
    const quotation = getQuotation();
    const isOperator = getIsOperatorFromSelector();
    handleObfuscatedFieldConsentReset({
      value: peselCheckoutForm || '',
      initialRun,
      messageKey: MessagesEnum.Coowners2PeselObfuscated,
      formName: FormsEnum.CheckoutForm,
      quotation,
      isOperator,
      resetTarget: {
        type: 'person',
        trackedPerson: 'coowner2',
        field: 'peselNumber',
      },
    });
  },
  showCoowners2PassportObfuscatedMessage(initialRun?: boolean) {
    const { passport } = getCheckoutCoownersData()[2];

    const showObfuscatedMessage = checkIsDataObfuscated(passport, initialRun);
    setMessageVisibility({
      key: MessagesEnum.Coowners2PassportObfuscated,
      visible: showObfuscatedMessage,
      formName: FormsEnum.CheckoutForm,
    });
  },
  showCoowners2FamilyNameObfuscatedMessage(initialRun?: boolean) {
    const { familyName } = getCheckoutCoownersData()[2];
    const showObfuscatedMessage = checkIsDataObfuscated(familyName, initialRun);

    setMessageVisibility({
      key: MessagesEnum.SecondCoownerFamilyNameObfuscated,
      visible: showObfuscatedMessage,
      formName: FormsEnum.CheckoutForm,
    });
  },
  showCoowners2LegalAddressStreetNameObfuscatedMessage(initialRun?: boolean) {
    const { legalAddress } = getCheckoutCoownersData()[2];

    const showObfuscatedMessage = checkIsDataObfuscated(
      legalAddress?.streetName,
      initialRun
    );

    setMessageVisibility({
      key: MessagesEnum.Coowners2LegalAddressStreetNameObfuscated,
      visible: showObfuscatedMessage,
      formName: FormsEnum.CheckoutForm,
    });
  },
};

export default obfuscation;
